import styles from "./Spacer.module.css";

function Spacer({ space }) {
  return <div style={{ height: space }}></div>;
}

export default Spacer;
